import { render, staticRenderFns } from "./settleInFoot.vue?vue&type=template&id=114982c4&scoped=true&"
import script from "./settleInFoot.vue?vue&type=script&lang=js&"
export * from "./settleInFoot.vue?vue&type=script&lang=js&"
import style0 from "./settleInFoot.vue?vue&type=style&index=0&id=114982c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114982c4",
  null
  
)

export default component.exports